import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronTopOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 9.01c-.26 0-.52.1-.7.3L3.32 21.27a.99.99 0 0 0 0 1.42c.4.4 1.02.4 1.42 0L16 11.43l11.26 11.26c.4.4 1.02.4 1.42 0s.4-1.02 0-1.42L16.7 9.31c-.2-.2-.46-.3-.7-.3" /></svg>;
export default SvgIconChevronTopOutlined;